// client/src/store/slices/VendorSlice.js

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isAuthenticated: false,
    vendor: null,
    token: null,
};

const vendorSlice = createSlice({
    name: 'vendor',
    initialState,
    reducers: {
        setVendor(state, action) {
            state.isAuthenticated = true;
            state.vendor = action.payload.vendor;
            state.token = action.payload.token;
        },
        clearVendor(state) {
            state.isAuthenticated = false;
            state.vendor = null;
            state.token = null;
        },
    },
});

export const { setVendor, clearVendor } = vendorSlice.actions;
export default vendorSlice.reducer;
